"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SlideWindow_1 = require("@/api/browser/SlideWindow");
var NAME = 'remslider';
var onScrollEnd = function (element, callback, timeout) {
    var handle = null;
    var onScroll = function () {
        if (handle)
            clearTimeout(handle);
        handle = setTimeout(callback, timeout || 200);
    };
    element.removeEventListener("scroll", onScroll);
    element.addEventListener("scroll", onScroll);
    return function () {
        element.removeEventListener("scroll", onScroll);
    };
};
var getVisibleSlide = function (slider) {
    var windowSize = slider.getAttribute('data-windowsize');
    if (windowSize)
        return Number(windowSize);
    var windowWidth = slider.clientWidth;
    var slides = Array.from(slider.children);
    var clientWidths = slides.map(function (it) { return it.clientWidth; });
    var offsetLefts = slides.map(function (it) { return it.offsetLeft; });
    var offsetRights = offsetLefts.map(function (it, i, arr) { return it - arr[0] + clientWidths[i]; });
    var maxVisibleItemCount = getFitSlideInWindowCount(windowWidth, offsetRights);
    return maxVisibleItemCount;
};
var getFitSlideInWindowCount = function (limit, breakpoints) { return breakpoints.map(function (it) { return limit > it; }).filter(function (it) { return it; }).length; };
var getNearestIndex = function (slider, currentX) {
    var viewportWidth = slider.clientWidth;
    var slides = Array.from(slider.children);
    var slideWidth = slides[0].clientWidth;
    var slidesOffsetLefts = slides.map(function (it) { return it.offsetLeft; });
    var centrePoints = slidesOffsetLefts.map(function (it) { return it + slideWidth / 2; });
    var diffs = centrePoints.map(function (it) {
        return Math.abs(it - (currentX + viewportWidth / 2));
    });
    var minIndex = diffs.indexOf(Math.min.apply(Math, diffs));
    return minIndex;
};
var getCurrentIndex = function (sliderElm) { return Number(sliderElm.getAttribute("data-current")); };
var setCurrentIndex = function (sliderElm, index) { return sliderElm.setAttribute("data-current", "" + index); };
var setSurroundingVisibility = function (slider, currentI, count) {
    var windowSize = getVisibleSlide(slider);
    var halfSize = Math.floor(windowSize / 2);
    var slides = Array.from(slider.children);
    var classname = Array.from(slides[0].classList).find(function (it) { return it.indexOf('c-') === 0; });
    slides.map(function (it) { return it.classList.remove(NAME + "-active"); });
    slides.map(function (it) { return it.classList.remove(classname + "--active"); });
    for (var i = currentI - halfSize; i <= currentI + halfSize; i++) {
        if (i < 0 || i >= count)
            continue;
        slides[i].classList.add(NAME + "-active");
        slides[i].classList.add(classname + "--active");
    }
};
var scrollSliderTo = function (slider, i, smooth) {
    if (smooth === void 0) { smooth = true; }
    var windowWidth = slider.clientWidth;
    var slides = Array.from(slider.children);
    var slidesCount = slides.length;
    var clientWidths = slides.map(function (it) { return it.clientWidth; });
    var offsetLefts = slides.map(function (it) { return it.offsetLeft; });
    var scrollLeftAtI = offsetLefts[i] - windowWidth / 2 + (clientWidths[i] / 2);
    slider.scrollTo({ left: Number(scrollLeftAtI), behavior: smooth ? "smooth" : "auto" });
    setSurroundingVisibility(slider, i, slidesCount);
};
var getMiddleSlide = function (slider) {
    var windowWidth = slider.clientWidth;
    var slides = Array.from(slider.children);
    var slidesCount = slides.length;
    var clientWidths = slides.map(function (it) { return it.clientWidth; });
    var offsetLefts = slides.map(function (it) { return it.offsetLeft; });
    var offsetRights = offsetLefts.map(function (it, i, arr) { return it - arr[0] + clientWidths[i]; });
    var maxVisibleItemCount = getFitSlideInWindowCount(windowWidth, offsetRights);
    var slideGroups = SlideWindow_1.slidewindowGroup(slidesCount, maxVisibleItemCount);
    if (!slideGroups.length)
        return -1;
    var firstSlideGroup = slideGroups[0];
    var middleSlide = firstSlideGroup[Math.floor(firstSlideGroup.length / 2)];
    return middleSlide;
};
var scrollLeft = function (slider) { return function () {
    var i = getCurrentIndex(slider);
    if (i === 0)
        return;
    scrollSliderTo(slider, i - 1, true);
}; };
var scrollRight = function (slider) { return function () {
    var slides = Array.from(slider.children);
    var slidesCount = slides.length;
    var i = getCurrentIndex(slider);
    if (i === slidesCount - 1)
        return;
    scrollSliderTo(slider, i + 1, true);
}; };
var initSliderControls = function (slider) {
    var sliderLeftBtn = slider.parentElement.querySelector("." + NAME + "-left");
    var sliderRightBtn = slider.parentElement.querySelector("." + NAME + "-right");
    if (!sliderLeftBtn)
        return;
    if (!sliderRightBtn)
        return;
    sliderLeftBtn.removeEventListener("click", scrollLeft(slider));
    sliderRightBtn.removeEventListener("click", scrollRight(slider));
    sliderLeftBtn.addEventListener("click", scrollLeft(slider));
    sliderRightBtn.addEventListener("click", scrollRight(slider));
};
var initSlideEndListener = function (slider) {
    var slides = Array.from(slider.children);
    var slidesCount = slides.length;
    onScrollEnd(slider, function () {
        var currentScrollLeft = slider.scrollLeft;
        var nearestIndex = getNearestIndex(slider, currentScrollLeft);
        setCurrentIndex(slider, nearestIndex);
        setSurroundingVisibility(slider, nearestIndex, slidesCount);
    }, 100);
};
var remslider = function (slider, iniIndex) {
    if (iniIndex === void 0) { iniIndex = -1; }
    var initSlideIndex = iniIndex > -1 ? iniIndex : getMiddleSlide(slider);
    if (initSlideIndex < 0)
        return;
    initSliderControls(slider);
    initSlideEndListener(slider);
    scrollSliderTo(slider, initSlideIndex, false);
};
exports.default = remslider;
